import * as types from './mutation-types'

export const mutations = {
    [types.LOG_IN](state) {
        state.loading = true;
        state.auth_error = null
    },
    [types.LOG_IN_SUCCESS](state, payload) {
        state.auth_error = null;
        state.isLoggedIn = true;
        state.loading = false;
        //state.currentUser = Object.assign({}, {token: payload.access}, {refresh_token: payload.refresh})
        state.authToken = 'Bearer ' + payload.access;
        localStorage.setItem('token', state.authToken)
    },
    [types.LOG_IN_FAILED](state, payload) {
        state.loading = false;
        state.auth_error = payload.error
    },
    [types.LOG_OUT](state) {
        localStorage.removeItem('token');
        state.isLoggedIn = false;
        state.authToken = null
    }
};